

import { Field, Switch } from "@fluentui/react-components";

export interface IBooleanInputProps {
    value: boolean
    label: string;
    onValueChange(value: boolean): void;
}

export const BooleanInput = (props: IBooleanInputProps) => {
    const { value, label, onValueChange } = props;

    const onValueChanged = (newValue: boolean) => {
        onValueChange(newValue);
    };

    return (
        <Field label={label}>
            <Switch
                aria-label="boolean switch"
                checked={value}
                onChange={(_, data) => onValueChanged(data.checked)}
                label={value ? "true" : "false"} />
        </Field>
    );
};